(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  window.SblaIngV1 = window.SblaIngV1 || {};
  window.SblaIngV1.init = function(sectionId) {
    var root = document.querySelector('[data-sbla-ing-v1-id="' + sectionId + '"]');
    if (!root) return;
    root.querySelectorAll('[data-sbla-ing-v1-card]').forEach(function(card) {
      var toggle = card.querySelector('.sbla-ing-v1-toggle');
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.setAttribute('aria-expanded', 'false');
      function toggleCard() {
        var isOpen = card.classList.toggle('sbla-ing-v1-is-open');
        card.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (toggle) toggle.textContent = isOpen ? 'Show less \u25b4' : 'Learn more \u25be';
      }
      card.addEventListener('click', toggleCard);
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCard(); }
      });
    });
  };

  } catch(e) { console.error(e); }
})();
})();
